import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Trans } from '@lingui/react';
import { Popover, Tooltip, Skeleton, Avatar } from '@tecsinapse/cortex-react';
import { Link } from 'react-router-dom';
import { useKeycloak } from '../core/context/keycloak.js';
import { i18n } from '../../utils/i18n.js';
import { useCoreQuery } from '../core/hooks/use-core-query.js';
import { useUserQuery } from '../core/hooks/use-user-query.js';

const AccountSettings = ({
  showMyAccount,
  customOptionsUser
}) => {
  const {
    data,
    isLoading
  } = useUserQuery();
  const {
    data: coreData
  } = useCoreQuery();
  const {
    logout
  } = useKeycloak();
  return /* @__PURE__ */ jsxs(Popover.Root, { trigger: "click", children: [
    /* @__PURE__ */ jsx(Popover.Trigger, { children: /* @__PURE__ */ jsx(Tooltip, { text: i18n._(
      /*i18n*/
      {
        id: "REJN7D"
      }
    ), children: isLoading ? /* @__PURE__ */ jsx(Skeleton, { className: "rounded-full w-8 h-8" }) : /* @__PURE__ */ jsx(Avatar, { name: String(data?.nome), src: String(data?.avatarLink), className: "mb-micro" }) }) }),
    /* @__PURE__ */ jsx(Popover.Content, { children: /* @__PURE__ */ jsxs("div", { className: "flex bg-white flex-col", children: [
      /* @__PURE__ */ jsxs("div", { className: "px-deca py-mili flex items-center gap-x-mili border-b border", children: [
        /* @__PURE__ */ jsx(Avatar, { name: String(data?.nome), src: String(data?.avatarLink) }),
        /* @__PURE__ */ jsx("p", { className: "text-sub", children: data?.nome })
      ] }),
      showMyAccount ? /* @__PURE__ */ jsx("div", { className: "flex items-center gap-x-mili hover:bg-secondary-light hover:cursor-pointer px-deca py-mili", children: /* @__PURE__ */ jsx("a", { href: `${coreData?.linkPortal}/minha-conta`, className: "no-underline text-sub text-black", children: /* @__PURE__ */ jsx(Trans, { .../*i18n*/
      {
        id: "nwikRk"
      } }) }) }) : /* @__PURE__ */ jsx(Fragment, {}),
      (customOptionsUser ?? []).length > 0 ? (customOptionsUser ?? []).map((option) => /* @__PURE__ */ jsx("div", { className: "flex items-center hover:bg-secondary-light hover:cursor-pointer px-deca py-mili text-sub text-black", children: /* @__PURE__ */ jsx(Link, { className: "no-underline text-sub text-black", to: option.path, children: /* @__PURE__ */ jsx("p", { children: option.label }) }) }, option.path)) : /* @__PURE__ */ jsx(Fragment, {}),
      /* @__PURE__ */ jsx("button", { onKeyDown: async () => await logout?.(), onClick: async () => await logout?.(), className: "flex items-center bg-white hover:bg-secondary-light px-deca py-mili text-sub text-black", children: /* @__PURE__ */ jsx(Trans, { .../*i18n*/
      {
        id: "8cDgMo"
      } }) })
    ] }) })
  ] });
};

export { AccountSettings };
